import React, { Component, Suspense, lazy, useContext } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import { connect, useSelector } from 'react-redux';
import { Fade } from 'react-bootstrap';
import { applicationContextActionCreator } from '../../store/actions';
import { AssureContext, UserProfile, UserSettings, UserChangePassword, Home, CodingWorksheet, CodingWorksheetPrint } from '../../components';
import MainHeader from './MainHeader';
import MainFooter from './MainFooter';
import MainSidebar from './MainSidebar';
import ModalRoot from '../../controls/modals/ModalRoot';
import { claims, claimValues } from '../../utilities/authConstants';
import * as AppComponents from '../../components';
import { AuthenticationService } from '../../services';
import _ from 'lodash';
import FullPageSpinner from '../../controls/FullPageSpinner';
import { useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { useEffect } from 'react';
import { useImmer } from 'use-immer';
import AssessmentQAReport from '../../components/report/AssessmentQAReport';
import CustomerQAReport from '../../components/customer/CustomerQAReport';
import CustomerCodingEventReport from '../../components/customer/CustomerCodingEventReport';
import CodingEventLocatorReport from '../../components/report/CodingEventLocatorReport';


//import nav from '../../nav';
//import routes from '../../routes';

const MainLayout = (props) => {
    const [routes, setRoutes] = useImmer([]);
    const [mainRoutes, setMainRoutes] = useState([]);
    const [hocRoutes, setHocRoutes] = useState([]);
    const [redirectRoutes, setRedirectRoutes] = useState([]);

    const authContext = useContext(AuthContext);
    const currentRoutes = authContext.currentUser?.routes;

    useEffect(() => {
        if (currentRoutes?.length > 0) {
            const tmpRoutes = _.cloneDeep(currentRoutes);
            tmpRoutes.forEach(route => {
                if (route.ComponentName !== '') {
                    route.component = AppComponents[route.componentName];
                }
            })
            setRoutes(tmpRoutes);
        }
    }, [currentRoutes])

    useEffect(() => {
        if (routes.length > 0) {
            setUpRoutes();
        }
    }, [routes])

    const setUpRoutes = () => {
        var regular = routes.filter(route => !route.groupComponentName && !route.redirectTo);
        var grouped = routes.filter(route => route.groupComponentName && !route.redirectTo);
        var redirect = routes.filter(route => !route.groupComponentName && route.redirectTo);

        let groupyGrouped = _.mapValues(_.groupBy(grouped, 'groupComponentName'),
            subList => subList.map(childRoute => _.omit(childRoute, 'groupComponentName')));
        groupyGrouped = Object.entries(groupyGrouped);
         
        var regularRoutes = regular.map((route, idx) => {
            var AppComponent = route.component;
            return AppComponent && (
                <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={props => (
                        <Fade>
                            <AppComponent {...props} />
                        </Fade>
                    )} />
            )
        });

        setMainRoutes(regularRoutes);

        var groupedRoutes = groupyGrouped.map((hoc, idx) => {
            const HocComponent = AppComponents[hoc[0]]
            console.log(`Building route - ${hoc[0]} HOC`)
            return HocComponent && (
                <HocComponent key={idx}>
                    <Switch>
                        {
                            hoc[1].map((route, idx2) => {
                                const AppComponent = route.component;
                                console.log(`Building route - ${route.componentName} Component`)
                                return AppComponent && (
                                    <Route
                                        key={idx2}
                                        path={route.path}
                                        exact={route.exact}
                                        name={route.name}
                                        render={props => (
                                            <Fade>
                                                <AppComponent {...props} />
                                            </Fade>
                                        )} />
                                )
                            })
                        }
                    </Switch>
                </HocComponent>
            );
        });

        setHocRoutes(groupedRoutes);

        let redirRoutes = redirect.map((route, idx) => {
            return (<Redirect exact strict key={idx} from={route.path} to={route.redirectTo} />)
        });

        setRedirectRoutes(redirRoutes);
    }

    return (
        <div className="app">
            <MainSidebar currentUser={authContext.currentUser} />
            <div className="main-wrapper">
                <MainHeader/>
                <FullPageSpinner>
                    <div className="main-bodys">
                        <main className="main">
                            <Suspense fallback={<div>Loading...</div>}>
                                <Switch>
                                    {
                                        authContext.currentUser?.dashboard ?
                                            <Redirect exact strict from="/" to={authContext.currentUser.dashboard} /> : null
                                    }
                                    <Route exact path="/home" name="Home" render={props => <Home {...props} />} />
                                    <Route exact path="/user" name="User" render={props => <UserProfile {...props} />} />
                                    <Route exact path="/user/password" name="Change Password" render={props => <UserChangePassword {...props} />} />
                                    <Route exact path="/user/settings" name="Settings" render={props => <UserSettings {...props} />} />
                                    {redirectRoutes}
                                    {mainRoutes}
                                    <Route exact path="/admin/reports/assessment/qa" name="Assessment QA Report" render={props => <AssessmentQAReport {...props} />} />
                                    <Route exact path="/admin/reports/assessment/raw" name="Customer Coding Event History Report" render={props => <CodingEventLocatorReport {...props} />} />
                                    <Route exact path="/customer/metrics/assessment/qa" name="Assessment QA Report" render={props => <CustomerQAReport {...props} />} />
                                    <Route exact path="/customer/metrics/codingevents/" name="Customer Coding Event History Report" render={props => <CustomerCodingEventReport {...props} />} />
                                </Switch>
                                {hocRoutes}
                            </Suspense>
                        </main>
                    </div>
                </FullPageSpinner>
                <MainFooter></MainFooter>
            </div>
            <ModalRoot />
        </div>
    )

}

export default MainLayout;